module.exports = __webpack_public_path__ + "static/media/group-icon.bbb99b21.svg";